import React from 'react'
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import Page from "../Page";
import MDBox from "../../materialDashboard/components/MDBox";
import MDButton from "../../materialDashboard/components/MDButton";
import useDataTable from "../../components/DataTable/useDataTable";
import ImportTasksTable from "./ImportTasksTable";
import {useImportTasksQuery} from "./query";

import Card from "@mui/material/Card";
import {useAuth} from "../../auth/AuthProvider";


const ImportTasks = () => {
    const {t} = useTranslation(['importTasks']);
    const navigate = useNavigate();
    const {workgroupAuthorization} = useAuth();

    const {fetchDataOptions, ...tableState} = useDataTable({dataTableId: "importTask", initialSorting: [{id: "createdAt", desc: false}]});
    const dataQuery = useImportTasksQuery(fetchDataOptions);

    return <Page path={"/importTasks"}>
        <MDBox mb={2} px={2}>
            {
                workgroupAuthorization.importTasks.create &&
                <MDButton variant="gradient" color="info" onClick={() => navigate("/importTasks/new")}>
                    {t('newImportTask')}
                </MDButton>
            }
            <Card sx={{mt: 2}}>
                <ImportTasksTable rows={dataQuery.data?.rows}
                                  page_count={dataQuery.data?.page_count}
                                  showRowColoring
                                  {...tableState}/>
            </Card>
        </MDBox>
    </Page>
}

export default ImportTasks